import DepositIcon from '@assets/icons/cross.svg?react'
import ExchangeIcon from '@assets/icons/exchange.svg?react'
import { CoreModalDialogFooter, MMButton } from '@components'
import parse from 'html-react-parser'
import { CustomerRoles, paths, selectCurrentUserRole, useAppSelector } from 'mmfintech-backend-api'
import { GlobalContext, tr } from 'mmfintech-commons'
import { useContext } from 'react'
import { useHistory } from 'react-router-dom'
import styles from './NoSuitableAccountModal.module.scss'

const NoSuitableAccountModal = () => {
  const { modalHide } = useContext(GlobalContext)

  const history = useHistory()
  const customerRole = useAppSelector(selectCurrentUserRole)

  const hasDepositAccess = customerRole !== CustomerRoles.STAFF
  const handleDepositClick = () => {
    history.push(paths.banking.deposit())
    modalHide()
  }

  const handleExchangeClick = () => {
    history.push(paths.banking.exchange())
    modalHide()
  }

  return (
    <>
      <div className={styles['modal-message-wrapper']} data-test='no-suitable-account-warning'>
        <div className='message-container'>
          {hasDepositAccess
            ? parse(
                tr(
                  'FRONTEND.WITHDRAW.NO_ACCOUNT.MESSAGE',
                  'You have no suitable account to initiate the payment. <b>Deposit</b> or <b>Exchange</b> respective funds to be able to send them.'
                )
              )
            : tr(
                'FRONTEND.WITHDRAW.NO_ACCOUNT.MESSAGE_STAFF',
                'You have no suitable account to initiate the payment. Please ask Administrator or the Owner to Deposit or Exchange funds to be able to send them.'
              )}
        </div>
      </div>

      <CoreModalDialogFooter>
        <div className={styles['no-suitable-accounts-actions']}>
          {hasDepositAccess ? (
            <>
              <MMButton
                type='button'
                size='large'
                variant='alternative'
                leftIcon={DepositIcon}
                caption={tr('FRONTEND.WITHDRAW.NO_ACCOUNT.BUTTON_DEPOSIT', 'Deposit')}
                onClick={handleDepositClick}
                data-test='button-deposit'
                fullWidth
              />
              <MMButton
                type='button'
                size='large'
                variant='alternative'
                leftIcon={ExchangeIcon}
                caption={tr('FRONTEND.WITHDRAW.NO_ACCOUNT.BUTTON_EXCHANGE', 'Exchange')}
                onClick={handleExchangeClick}
                data-test='exchange-button'
                fullWidth
              />
            </>
          ) : (
            <MMButton
              type='button'
              size='large'
              variant='alternative'
              caption={tr('FRONTEND.BUTTONS.OK', 'OK')}
              onClick={modalHide}
              data-test='exchange-button'
              fullWidth
            />
          )}
        </div>
      </CoreModalDialogFooter>
    </>
  )
}

export default NoSuitableAccountModal
